import * as commitTypes from './commitTypes';

const persistState = state => {
    // const theState = {...state};
    // const blackList = ['updateRequired'];
    // blackList.map(key => (delete theState[key]));
    localStorage.setItem('bm_state', JSON.stringify(state));
}

export default {
    [commitTypes.SET_USER](state, user) {
        state.user = user;
        persistState(state);
    },
    [commitTypes.SET_VISITS](state, visits){
        state.visits = visits;
        persistState(state);
    },
    [commitTypes.SET_MAILS](state, mails){
        state.mails = mails;
        persistState(state);
    },
    [commitTypes.SET_HAS_SUBS](state, hasSubs){
        state.hasSubscriptions = !!hasSubs;
    },
    [commitTypes.SET_STATE](state, initialState) {
        Object.keys(initialState).forEach(key => state[key] = initialState[key]);
    },
    [commitTypes.SET_UPDATED_EMAIL](state, updatedEmail) {
        state.updatedEmail = updatedEmail;
    },
    [commitTypes.SET_VERSION](state, version) {
        state.version = version;
        persistState(state);
    },
    [commitTypes.SET_REQUIRE_UPDATE](state, updateRequired) {
        state.updateRequired = updateRequired;
        persistState(state);
    }
};



// WEBPACK FOOTER //
// ./src/store/mutations.js